/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, dialogPolyfill, document, location, navigator, window */

blacksunplc.events.ready(function () {
    "use strict";

    var configNewAndEventCarousel = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,

    }

    var configbrandCarousel = {
        speed: 8000,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        autoplaySpeed: 0,
        responsive: [{
            breakpoint: 1280,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 3
            }
        }]
    }

    var founderCarousel = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        fade: true
    }

    var interviewCarousel = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000
    }
    var galleryCarousel = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        }]
    }

    var configImpactCarousel = { ...configNewAndEventCarousel }
    var articleCarousel = { ...configNewAndEventCarousel }
    configImpactCarousel.arrows = true;
    articleCarousel.slidesToShow = 2;
    articleCarousel.responsive = [
        {
            breakpoint: 601,
            settings: {
                slidesToShow: 1
            }
        }
    ]
    var cultureTimelineCarousel = { ...configNewAndEventCarousel }
    cultureTimelineCarousel.slidesToShow = 4;
    cultureTimelineCarousel.responsive = [
        {
            breakpoint: 601,
            settings: {
                slidesToShow: 1
            }
        }
    ]
    var configbrandCarouselRtl = { ...configbrandCarousel }
    configbrandCarouselRtl.rtl = true;

    $(".impact-slider").each(function () {
        var $root = $(this);
        var $controls = $root.find('header .button.secondary-btn .impact-slider-arrows');
        var instanceConfig = { ...configImpactCarousel };
        
        if ($controls.length) {
            instanceConfig.appendArrows = $controls;
            instanceConfig.prevArrow = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">Previous<\/button>';
            instanceConfig.nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button">Next<\/button>';
            instanceConfig.responsive = [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                }
            }
        ];
        }
        var $list = $root.find('.impact-slider-list');
        function forceReflow(el) {
            try { void el.offsetWidth; } catch (e) { }
        }

        function setDropInForIndex(index) {
            var $slides = $list.find('.slick-slide');
            // Clear active animation classes
            $slides.find('.article__media img').removeClass('drop-in');
            $slides.find('.article__detail').removeClass('detail-drop-in');
            // Target the current slide
            var $current = $list.find('.slick-slide.slick-current');
            if (!$current.length) {
                $current = $slides.filter('[data-slick-index="' + index + '"]');
            }
            var $imgs = $current.find('.article__media img');
            var $details = $current.find('.article__detail');
            // Prepare and animate
            $imgs.addClass('prepare-curtain');
            $details.addClass('prepare-detail');
            window.requestAnimationFrame(function () {
                $imgs.addClass('drop-in');
                setTimeout(function () {
                    $details.addClass('detail-drop-in');
                }, 400);
            });
        }

        // Return all slick slides (originals and clones) that correspond to a logical index
        function getSlidesByLogicalIndex(index) {
            var inst;
            try { inst = $list.slick('getSlick'); } catch (e) { inst = null; }
            var count = inst ? inst.slideCount : $list.find('.slick-slide:not(.slick-cloned)').length;
            var $matches = $();
            $list.find('.slick-slide').each(function () {
                var raw = parseInt(this.getAttribute('data-slick-index'), 10);
                if (isNaN(raw)) { return; }
                var norm = ((raw % count) + count) % count;
                if (norm === index) { $matches = $matches.add(this); }
            });
            return $matches;
        }

        // Animate a specific slide by its index
        function setDropInForExactIndex(index) {
            var $target = getSlidesByLogicalIndex(index);
            var $img = $target.find('.article__media img');
            var $detail = $target.find('.article__detail');
            // Prepare and animate
            $img.addClass('prepare-curtain');
            $detail.addClass('prepare-detail');
            window.requestAnimationFrame(function () {
                $img.addClass('drop-in');
                setTimeout(function () {
                    $detail.addClass('detail-drop-in');
                }, 400);
            });
        }

        $list.on('init', function (event, slick) {
            setTimeout(function () {
                $list.addClass('is-ready');
                // Prepare all slides to be hidden initially
                $list.find('.slick-slide .article__media img').addClass('prepare-curtain');
                $list.find('.slick-slide .article__detail').addClass('prepare-detail');
                // Pre-hide upcoming slides to prevent peeking
                try {
                    var inst0 = $list.slick('getSlick');
                    var next0 = (inst0.currentSlide + 1) % inst0.slideCount;
                    var $nextSlide0 = getSlidesByLogicalIndex(next0);
                    $nextSlide0.find('.article__media img').addClass('prepare-curtain');
                    $nextSlide0.find('.article__detail').addClass('prepare-detail');
                    var next0b = (inst0.currentSlide + 2) % inst0.slideCount;
                    var $nextSlide0b = getSlidesByLogicalIndex(next0b);
                    $nextSlide0b.find('.article__media img').addClass('prepare-curtain');
                    $nextSlide0b.find('.article__detail').addClass('prepare-detail');
                } catch (e) { }
                // Watch for when the slider becomes visible to trigger initial animation
                try {
                    var hasTriggeredInitialAnimation = false;
                    var observer = new MutationObserver(function (mutations) {
                        mutations.forEach(function (m) {
                            if (m.attributeName === 'class') {
                                var nowVisible = $list.hasClass('visible');
                                if (nowVisible && !hasTriggeredInitialAnimation) {
                                    hasTriggeredInitialAnimation = true;
                                    $list.data('hasCompletedInitialAnimation', true);

                                    // Reset and prepare for animation
                                    $list.find('.article__media img').removeClass('prepare-curtain drop-in');
                                    $list.find('.article__detail').removeClass('prepare-detail detail-drop-in');
                                    var $cur = $list.find('.slick-slide.slick-current');
                                    $cur.find('.article__media img').addClass('prepare-curtain');
                                    $cur.find('.article__detail').addClass('prepare-detail');

                                    // Pre-hide upcoming slides
                                    try {
                                        var instV = $list.slick('getSlick');
                                        var nextV = (instV.currentSlide + 1) % instV.slideCount;
                                        var $nextSlideV = getSlidesByLogicalIndex(nextV);
                                        $nextSlideV.find('.article__media img').addClass('prepare-curtain');
                                        $nextSlideV.find('.article__detail').addClass('prepare-detail');
                                        var nextVb = (instV.currentSlide + 2) % instV.slideCount;
                                        var $nextSlideVb = getSlidesByLogicalIndex(nextVb);
                                        $nextSlideVb.find('.article__media img').addClass('prepare-curtain');
                                        $nextSlideVb.find('.article__detail').addClass('prepare-detail');
                                    } catch (e) { }

                                    // Start initial animation sequence
                                    setTimeout(function () {
                                        setDropInForIndex(slick.currentSlide);
                                        try {
                                            var inst = $list.slick('getSlick');
                                            var nextIdx = (inst.currentSlide + 1) % inst.slideCount;
                                            var tid = setTimeout(function () {
                                                setDropInForExactIndex(nextIdx);
                                                // Clean up all hiding classes for normal navigation
                                                setTimeout(function () {
                                                    $list.find('.article__media img').removeClass('prepare-curtain').addClass('drop-in');
                                                    $list.find('.article__detail').removeClass('prepare-detail').addClass('detail-drop-in');
                                                }, 500);
                                            }, 1600);
                                            $list.data('nextDropTimeout', tid);
                                        } catch (e) { }
                                    }, 200);
                                }
                            }
                        });
                    });
                    observer.observe($list.get(0), { attributes: true });
                } catch (e) { }
            }, 0);
        });
        $list.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // After initial animation is complete, let Slick work normally
            if ($list.data('hasCompletedInitialAnimation')) {
                return;
            }

            // Clear active animation classes
            $list.find('.article__media img').removeClass('drop-in');
            $list.find('.article__detail').removeClass('detail-drop-in');
            // Cancel any scheduled animations
            var pending = $list.data('nextDropTimeout');
            if (pending) {
                try { clearTimeout(pending); } catch (e) { }
                $list.removeData('nextDropTimeout');
            }
            $list.data('pendingDropIndex', nextSlide);

            // Hide incoming slides for animation
            var next2 = (nextSlide + 1) % slick.slideCount;
            var $in = getSlidesByLogicalIndex(nextSlide);
            var $in2 = getSlidesByLogicalIndex(next2);
            $in.find('.article__media img').addClass('prepare-curtain');
            $in.find('.article__detail').addClass('prepare-detail');
            $in2.find('.article__media img').addClass('prepare-curtain');
            $in2.find('.article__detail').addClass('prepare-detail');
        });
        $list.on('afterChange', function (event, slick, currentSlide) {
            // After initial animation is complete, let Slick work normally
            if ($list.data('hasCompletedInitialAnimation')) {
                return;
            }

            // Trigger animation for current slide
            var targetIndex = typeof $list.data('pendingDropIndex') !== 'undefined' ? $list.data('pendingDropIndex') : currentSlide;
            if (targetIndex !== currentSlide) { targetIndex = currentSlide; }
            setTimeout(function () {
                setDropInForIndex(targetIndex);
            }, 120);

            // Schedule next slide animation
            try {
                var instA = $list.slick('getSlick');
                var nextIdxA = (instA.currentSlide + 1) % instA.slideCount;
                var $nextA = $list.find('.slick-slide[data-slick-index="' + nextIdxA + '"]');
                var nextIdxB = (instA.currentSlide + 2) % instA.slideCount;
                var $nextB = $list.find('.slick-slide[data-slick-index="' + nextIdxB + '"]');
                $nextA.find('.article__media img').addClass('prepare-curtain');
                $nextA.find('.article__detail').addClass('prepare-detail');
                $nextB.find('.article__media img').addClass('prepare-curtain');
                $nextB.find('.article__detail').addClass('prepare-detail');
                var tidA = setTimeout(function () {
                    setDropInForExactIndex(nextIdxA);
                }, 1600);
                $list.data('nextDropTimeout', tidA);
            } catch (e) { }
        });

        // Fallback: ensure ready state is set
        setTimeout(function () {
            if (!$list.hasClass('is-ready')) {
                $list.addClass('is-ready');
                if (!$list.data('hasCompletedInitialAnimation')) {
                    try {
                        var instance = $list.slick('getSlick');
                        setDropInForIndex(instance ? instance.currentSlide : 0);
                    } catch (e) { }
                }
            }
        }, 500);
        $list.slick(instanceConfig);
    });
    $(".cmp-news-events").each(function () {
        var $root = $(this);
        var $controls = $root.find('.news-events-controls .news-events-arrows');
        var instanceConfig = { ...configNewAndEventCarousel };
        if ($root.hasClass('cmp-news-events--our-future')) {
            instanceConfig.slidesToShow = 2;
            instanceConfig.infinite = true;
            instanceConfig.responsive = [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ];
        }
        if ($controls.length) {
            instanceConfig.appendArrows = $controls;
            instanceConfig.prevArrow = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">Previous<\/button>';
            instanceConfig.nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button">Next<\/button>';
        }
        $root.find('.news-events-slider').slick(instanceConfig);
    });
    $(".cmp-article-slider__list").slick(articleCarousel);
    $(".investor-page .timeline-slider-list").slick(articleCarousel);
    $(".culture-page .timeline-slider-list").slick(cultureTimelineCarousel);
    $("body:not(.ourfuture-page) .interview-slider-list").slick(interviewCarousel);
    $(".ourfuture-page .interview-slider-list blockquote").slick(interviewCarousel);
    $(".founder-slider-list").slick(founderCarousel);
    $(".quote-slider-list").not('.slick-initialized').slick(founderCarousel);
    $(".collective-impact-slider").each(function () {
        var $slider = $(this);
        $slider.slick(founderCarousel);

        $slider.on('afterChange', function (event, slick, currentSlide) {
            // Only for join-the-group page
            var $diagram = $('.impact-diagram');
            if ($diagram.length && $('.join-the-group-page').length) {
                $diagram.find('path').removeClass('active-fill active-text-fill');
                if (currentSlide === 1) {
                    $diagram.find('.text-second').addClass('active-fill');
                    $diagram.find('.color-text-second').addClass('active-text-fill');
                } else if (currentSlide === 2) {
                    $diagram.find('.text-third').addClass('active-fill');
                    $diagram.find('.color-text-third').addClass('active-text-fill');
                } else if (currentSlide === 3) {
                    $diagram.find('.text-fourth').addClass('active-fill');
                    $diagram.find('.color-text-fourth').addClass('active-text-fill');
                }
            }
        });

        // SVG Interactivity
        var $diagram = $('.impact-diagram');
        if ($diagram.length && $('.join-the-group-page').length) {
            $diagram.find('.text-second, .color-text-second').on('mouseenter', function () {
                $slider.slick('slickGoTo', 1);
            });
            $diagram.find('.text-third, .color-text-third').on('mouseenter', function () {
                $slider.slick('slickGoTo', 2);
            });
            $diagram.find('.text-fourth, .color-text-fourth').on('mouseenter', function () {
                $slider.slick('slickGoTo', 3);
            });
        }
    });
    $(".brand-slider").slick(configbrandCarousel);

    // Our Difference page slider - shows 3.5 items with infinite loop
    var configOurDifferenceSlider = {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: 'ease-in-out',
        centerMode: false,
        initialSlide: 0,
        rtl: false,
        responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        },  {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }]
    };

    $("#our-difference-slider .our-difference-items").each(function () {
        var $root = $(this).closest('#our-difference-slider');
        var $controls = $root.find('header .button.secondary-btn .impact-slider-arrows');
        var instanceConfig = { ...configOurDifferenceSlider };
        if ($controls.length) {
            instanceConfig.appendArrows = $controls;
            instanceConfig.prevArrow = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">Previous<\/button>';
            instanceConfig.nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button">Next<\/button>';
        }
        $(this).slick(instanceConfig);
    });
    $(".brand-slider-rtl").slick(configbrandCarouselRtl);
    $(".image-galleries .image-gallery .images").each(function () {
        $(this).slick(galleryCarousel);
    });
    $(".big-slider__list").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        cssEase: 'linear',
        pauseOnHover: false, 
        pauseOnFocus: false,
        pauseOnDotsHover: false
    });
});
